<app-day-schedule [widgetData]="widgetData" [currentDate]="selectedDay"/>